import React from 'react';
import { compose, hoistStatics, defaultProps } from 'recompose';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import Items from './Items';
import columnTypes from '../../components/cms/grid/columnTypes';
import ModelService from '../../services/notification.service';
import gc from '../../components/cms/gridComponents';
import PreviewImage from '../../components/previewImage';

const getColumns = t => [
  {
    name: 'id',
    title: t('Id'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.id}</Link>),
  },
  // {
  //   name: 'image',
  //   title: '',
  //   value: ({ item }) => (
  //     <div className="center">
  //       <Link to={ModelService.getUpdateUrl(item.id)}>
  //         <PreviewImage height="35" src={ModelService.getImage(item.image, 100, 100)} alt={item.title} />
  //       </Link>
  //     </div>
  //   ),
  //   filter: false,
  //   sort: false,
  // },
  {
    name: 'title',
    title: t('Title'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.title}</Link>),
  },
  {
    name: 'content',
    title: t('Content'),
    filter: false,
  },
  {
    name: 'status',
    title: t('Status'),
    value: ({ item: { status } }) => (
      <Badge color={ModelService.getColorByStatus(status)}>
        {ModelService.getStatusTitle(status, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getStatusOptions(t)),
  },
  // {
  //   name: 'is_default',
  //   title: t('Is default'),
  //   value: ({ item: { is_default } }) => (
  //     <Badge color={ModelService.getColorByStatus(is_default)}>
  //       {ModelService.getStatusTitle(is_default, t)}
  //     </Badge>
  //   ),
  //   filter: gc.selectFilter(ModelService.getStatusOptions(t)),
  // },
  {
    type: columnTypes.BUTTONS,
  },
];

const enhance = compose(
  translate('core'),
  defaultProps({
    getColumns,
    service: ModelService,
  }),
);

export default hoistStatics(enhance)(Items);



// WEBPACK FOOTER //
// ./src/views/notifications/index.js